interface CreateBandModalProps {
  onClose: () => void;
}

const CreateBandModal = ({ onClose }: CreateBandModalProps) => {
  const handleSubmit = () => {
    alert("バンドが作成されました！");
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl p-6 w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4">🎸 新しいバンドを作成</h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              バンド名
            </label>
            <input
              type="text"
              placeholder="バンド名を入力"
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              ジャンル
            </label>
            <select className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              <option>ロック</option>
              <option>ポップス</option>
              <option>ジャズ</option>
              <option>メタル</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              活動エリア
            </label>
            <select className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              <option>東京都</option>
              <option>大阪府</option>
              <option>神奈川県</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              目標・コンセプト
            </label>
            <textarea
              placeholder="バンドの目標やコンセプトを入力"
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent h-20 resize-none"
            />
          </div>
        </div>
        <div className="flex space-x-3 mt-6">
          <button
            onClick={onClose}
            className="flex-1 py-3 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 transition-colors"
          >
            キャンセル
          </button>
          <button
            onClick={handleSubmit}
            className="flex-1 gradient-bg text-white py-3 rounded-lg font-medium hover:opacity-90 transition-opacity"
          >
            作成する
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateBandModal;
